import { setRowTestId } from "@bcc/components/data-table/data-table.utils";
import { generateTestId } from "@client-shared";
import { TOUR_ID_ATTRIBUTE } from "./tour-ids";

export const setTourTestId = (identifier: string): string => generateTestId("Tour", identifier);

/** CSS selector for a tour anchor, e.g. `[data-tour-id="batches-table"]` */
export const tourTargetSelector = (tourId: string): string => `[${TOUR_ID_ATTRIBUTE}="${tourId}"]`;

/** CSS selector for an element by its exact test id */
export const testIdSelector = (testId: string): string => `[data-testid="${testId}"]`;

/** CSS selector for elements whose test id starts with `prefix` */
export const testIdPrefixSelector = (prefix: string): string => `[data-testid^="${prefix}"]`;

/** CSS selector for elements whose test id contains `fragment` (ids that start with a dynamic entity id) */
export const testIdContainsSelector = (fragment: string): string => `[data-testid*="${fragment}"]`;

/** Any rendered DataTable row — used by `detectTarget` on table steps */
export const DATA_TABLE_ROW_SELECTOR = testIdPrefixSelector(setRowTestId(""));
